$( document ).on('turbolinks:load', function() {
  

});
